import {
  GET_FORMS,
  POST_FORM,
  FORMS_BY_PATIENT
  // DELETE_OR_PATCH_FORM
} from "resources/ApiUrls"
import MyAxiosInstance from "utils/MyAxiosInstance"

const getAll = (centerId) => MyAxiosInstance.get(GET_FORMS(centerId))

const create = (formObj, centerId) => MyAxiosInstance.post(POST_FORM(centerId), formObj)


const getAllByPatient = (patientId) => MyAxiosInstance.get(FORMS_BY_PATIENT(patientId))


// const remove = (noteId) => MyAxiosInstance.delete(DELETE_OR_PATCH_FORM(formId))

// const update = (noteId, fieldsToUpdate) => MyAxiosInstance.patch(DELETE_OR_PATCH_FORM(formId), fieldsToUpdate)

const formsAPICalls = { getAll, create, getAllByPatient }

export default formsAPICalls